import { styled } from '@material-ui/core';

import { Typography } from 'shared/components/typography/Typography';

export const Content = styled(Typography)(({ theme: { palette } }) => ({
  color: palette.blue.dark,
}));
